var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("a", { attrs: { href: _vm.url, target: _vm.target } }, [
    _c("div", { staticClass: "c-teaser-gallery-intro__wrapper" }, [
      _c("div", { staticClass: "c-teaser-gallery-intro__inner" }, [
        _c("div", {
          staticClass: "c-teaser-gallery-intro__bg",
          style: { background: "url(" + _vm.image + ") no-repeat" }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "c-teaser-gallery-intro__content" },
          [
            _c("v-icon", { attrs: { name: _vm.icon, size: "xxl" } }),
            _vm._v(" "),
            _c("h2", { staticClass: "c-teaser-gallery-intro__heading" }, [
              _vm._v(_vm._s(_vm.heading))
            ]),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.text))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "c-teaser-gallery-intro__content--arrow" },
              [_c("v-icon", { attrs: { name: "icon-chevron", size: "3" } })],
              1
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }